import { NodeViewWrapper } from "@tiptap/react";
import skuImage from '../../../../../assets/images/whtchoosemalmart/sku.png';
import deliveryImage from '../../../../../assets/images/whtchoosemalmart/delivery.png';
import brandImage from '../../../../../assets/images/whtchoosemalmart/brand.png';
import lowestImage from '../../../../../assets/images/whtchoosemalmart/lowest.png';
import supportImage from '../../../../../assets/images/whtchoosemalmart/support.png';

const whyChooseData = [
    {
        title: "20,000+ SKUs",
        description: "A massive collection of construction and interior products — everything you need in one place.",
        imagePath: skuImage
    },
    {
        title: "Fast Delivery",
        description: "Timely deliveries with our dedicated fleet — ensuring your materials reach on schedule.",
        imagePath: deliveryImage
    },
    {
        title: "100+ Brands",
        description: "Partnered with India's top brands like TATA, JSW, Ultratech, and more.",
        imagePath: brandImage
    },
    {
        title: "Lowest Prices",
        description: "Premium quality materials at competitive prices — value you can trust.",
        imagePath: lowestImage
    },
    {
        title: "Expert Support",
        description: "Get expert guidance from our team — we're here to help every step of your project.",
        imagePath: supportImage
    }
];

export const WhyChooseMalMartBlockView = (props) => {
    const { editor, getPos } = props;

    const handleCaptionClick = () => {
        const nodePosition = getPos();
        editor.commands.setNodeSelection(nodePosition);
    };

    return (
        <NodeViewWrapper data-type='whychoosemalmart'>
            <div className="whychoosemalmart-node-wrapper">
                <div onClick={handleCaptionClick}>
                    <div className='whychoosemalmart-content'>
                        <div className="whychoosemalmart-grid">
                            {whyChooseData.map((item, index) => (
                                <div key={index} className="whychoosemalmart-item">
                                    <div className="whychoosemalmart-image">
                                        <img src={item.imagePath} alt={item.title} />
                                    </div>
                                    <h3 className="whychoosemalmart-title">{item.title}</h3>
                                    <p className="whychoosemalmart-description">{item.description}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </NodeViewWrapper>
    );
};